export const visit = (vm, at) => {
at({ "id": { "conversations-message-history": { "status": { "closed": "Utas ini ditutup pada {{ dateString }}", "restore": "Pulihkan pesan ini", "publishing": { "UNPUBLISHED": "Mengiirm... ", "PUBLISH_FAILED": "Tidak terkirim. Klik untuk mencoba lagi." } } } } });
};